module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-display-three",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemData.img
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.itemData.name))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14faebaf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Skill.vue
// module id = 678
// module chunks = 1